import ProgressSpinner from "../../components/progressSpinner/ProgressSpinner";

function VerifyingActionCode() {
    return (<>
        <ProgressSpinner />
    </>);
}

export default VerifyingActionCode;